import { FormattedMessage } from 'react-intl';

import Counter from '../../../../components/Counter/Counter';
import Icon from '../../../../components/Icon/Icon';
import { TranslatedRootSustainableActionsT } from '../../../../pages/SustainableActionsPage/hooks/useSustainableActions';
import Price from '../../../Price/Price';
import DetailsCard from '../../DetailsCard';
import {
  MetadataItemStyled,
  MetadataLabelStyled,
  MetadataRowStyled,
} from '../../DetailsCard.styled';
import {
  CounterLabelStyled,
  GoalIconsWrapperStyled,
  SdgAlignmentWrapperStyled,
} from './SustainableActionCard.styled';

type SustainableActionCardPropsT = {
  onChangeCounter: (val: number) => void;
} & TranslatedRootSustainableActionsT;

const SustainableActionCard: React.FC<SustainableActionCardPropsT> = ({
  name,
  type,
  impact,
  country,
  pricePerUnit,
  description,
  thumbnailDetails,
  image,
  qty,
  projectOwner,
  fundraisingGoal,
  amountRaised,
  onChangeCounter,
}) => {
  // TODO figure out if possible receive Number[] instead of string
  const sdgGoalNumberList = thumbnailDetails?.title
    ?.split(',')
    .map(title => title?.trim() || null)
    .filter(title => title !== null && parseInt(title) > 0 && parseInt(title) < 18);

  const renderMetaData = () => (
    <>
      <MetadataRowStyled>
        <MetadataItemStyled>
          <MetadataLabelStyled>
            <FormattedMessage id="foundItem.type" defaultMessage="Type" />:{' '}
          </MetadataLabelStyled>
          {type}
        </MetadataItemStyled>
        <MetadataItemStyled>
          <MetadataLabelStyled>
            <FormattedMessage id="foundItem.cost" defaultMessage="Unit Cost" />:{' '}
          </MetadataLabelStyled>
          <Price amount={pricePerUnit} />
        </MetadataItemStyled>
      </MetadataRowStyled>
      <MetadataRowStyled>
        <MetadataItemStyled>
          <MetadataLabelStyled>
            <FormattedMessage id="foundItem.impact" defaultMessage="Impact" />:{' '}
          </MetadataLabelStyled>
          {impact}
        </MetadataItemStyled>
        <MetadataItemStyled>
          <MetadataLabelStyled>
            <FormattedMessage id="foundItem.country" defaultMessage="Country" />:{' '}
          </MetadataLabelStyled>
          {country}
        </MetadataItemStyled>
      </MetadataRowStyled>

      <SdgAlignmentWrapperStyled>
        <MetadataLabelStyled>
          <FormattedMessage id="foundItem.alignment" defaultMessage="SDG Alignment" />:
        </MetadataLabelStyled>
        <GoalIconsWrapperStyled>
          {sdgGoalNumberList.map((number, index) => (
            <Icon key={index} fileName={`goals/goal-${number}`} />
          ))}
        </GoalIconsWrapperStyled>
      </SdgAlignmentWrapperStyled>
    </>
  );

  const renderCounter = () => (
    <>
      <CounterLabelStyled>
        <FormattedMessage id="foundItem.selectQuantity" defaultMessage="Select Quantity" />
      </CounterLabelStyled>
      <Counter min={0} max={100} value={qty} onChange={onChangeCounter} />
    </>
  );

  return (
    <DetailsCard
      title={name}
      imageUrl={image}
      description={description}
      childrenMeta={renderMetaData()}
      childrenRightCol={renderCounter()}
      projectOwner={projectOwner}
      goalPrice={+fundraisingGoal}
      raisedPrice={amountRaised}
    />
  );
};

export default SustainableActionCard;
